import { Outlet, useNavigate } from 'react-router-dom';
import { useChatContext } from '../../context/ChatContextProvider';
import { useEffect } from 'react';
import { CHAT_LIST_PATH, CHAT_CONVERSATION_PATH } from '../../pathNames';

/**
 * This is the main chat page that renders the chat list or the chat conversation
 * It also handles the navigation between the chat list and the chat conversation
 * <Route path="list" element={<ChatsList />} />
 * <Route path="conversation" element={<ChatConversation />} />
 */
const ChatPage = () => {
  const navigate = useNavigate();
  const { activeChatId } = useChatContext();

  useEffect(() => {
    if (!activeChatId) {
      navigate(CHAT_LIST_PATH);
    } else {
      navigate(CHAT_CONVERSATION_PATH);
    }
  }, [activeChatId]);

  return <Outlet />;
};

export default ChatPage;
